import { useState, useEffect } from 'react';
import {accountsTypes} from '../../../content/accountsTypes';
import GoogleLogo from '../../../images/googleGLogo.svg';
import AccountBox from '../AccountBox/AccountBox';
import * as Styled from './AccountsStyles';
import {Row, Col} from 'react-bootstrap';
import {isEmpty} from 'lodash';

interface AccountsProps {
  subscriptions: null | object;
  connectionLinks: null | object;
  isLoading: boolean;
}

export interface accountProps {
  name: string;
  shortName: string;
  icon: string | any;
  connectionLink?: string | string[];
  isConnected?: boolean;
  displayNameProp?: string;
  accountDisplayName?: string;
  subs?: Array<any>;
  token_status?: string;
  indexingAccounts?: boolean;
  o365?: boolean;
}

const initialAccount = {
  name: '',
  shortName: '',
  icon: '',
  connectionLink: '',
  isConnected: false,
  displayNameProp: '',
  accountDisplayName: '',
  subs: [],
}

const setupAccounts = (subscriptions: object | any, links: object | any) => {
  return accountsTypes.map(acc => {
    const res: accountProps = { ...initialAccount, ...acc };
    res.connectionLink = '';
    if (links) {
      res.connectionLink = links[acc.shortName];
      if (res.shortName === 'teams') {
        res.connectionLink = [
          res.connectionLink,
          links['teams-fullscope'],
        ]
      }
    }
    res.subs = [];
    if (subscriptions) {
      res.subs = subscriptions[acc.shortName];
    }

    if (acc.shortName === 'gmail' || acc.shortName === 'gdrive') {
      res.icon = {
        ...res.icon,
        default: GoogleLogo,
      }
    }

    if (res.subs && res.subs.length) {
      res.isConnected = true;
      res.accountDisplayName = res.displayNameProp ? res.subs[0][res.displayNameProp] : '';
      if (res.subs.length > 1) {
        res.accountDisplayName = `${res.subs.length} accounts connected`
      }
    }
    const requiresAttention = res.subs?.find(s => s.token_status && s.token_status !== 'valid');
    if (requiresAttention) {
      res.token_status = requiresAttention.token_status;
      res.o365 = requiresAttention.o365 && !requiresAttention.teams;
    }

    res.indexingAccounts = res.subs?.some(s => {
      return s.teams && (s.data_status === 'in-progress' || s.teams_data_status === 'in-progress')
    }) || false;

    return { ...res };
  }).sort((a, b) => {
    if (a.connectionLink && !b.connectionLink) {
      return -1;
    }
    if (!a.connectionLink && b.connectionLink) {
      return 1;
    }
    return 0;
  })
}

const Accounts = ({ isLoading, subscriptions, connectionLinks } : AccountsProps) => {
  const [accounts, setAccounts] = useState<Array<any>>([]);
  useEffect(() => {
    if (isEmpty(connectionLinks)) {
      return;
    }
    setAccounts(setupAccounts(subscriptions, connectionLinks));
  }, [subscriptions, connectionLinks]);
  if (isLoading || !accounts.length) {
    return null;
  }

  return (
    <Styled.AccountsContainer className='AccountsWrapper' fluid="xl">
      <Row>
        <Col xs={12}>
          <Styled.StyledH2>Accounts</Styled.StyledH2>
        </Col>
      </Row>
      <Row>
        {
          accounts.map( (e, i) => {
            return (
              <Col key={e.shortName} xs={12} sm={6} md={6} lg={4}>
                <AccountBox
                  service={e}
                  list={['Add Account', 'Disconnect']}
                />
              </Col>
            )
          })
        }
      </Row>
    </Styled.AccountsContainer>
  );
}

export default Accounts;